import React from 'react'
import cn from 'classnames'
import { chatBubbleUser as AssignIcon } from 'assets/icons/groove/v2'
import AssignmentButtonView from 'components/ConversationHeader/Buttons/AssignmentButton'
import { Tooltip } from 'shared/ui'

const AssignmentButton = React.memo(
  ({
    assignmentOpen,
    isAssigned,
    assignedGroupId,
    assignmentAgentName,
    onAssignmentIconClick,
    onAssignmentDropdownClose,
    AssignmentDropdown = AssignmentButtonView,
  }) => {
    return (
      <div className="assignment">
        {!assignmentOpen && (
          <a
            className={cn('menu-button', { assigned: isAssigned })}
            onClick={onAssignmentIconClick}
          >
            {isAssigned && (
              <Tooltip
                as="span"
                className="label"
                position="bottom"
                tooltip={`Reassign (${assignmentAgentName}) [a]`}
              >
                {assignmentAgentName}
              </Tooltip>
            )}
            {!isAssigned && (
              <Tooltip position="bottom" tooltip={`Assign a]`}>
                <AssignIcon />
              </Tooltip>
            )}
          </a>
        )}
        {assignmentOpen && (
          <AssignmentDropdown
            direction="right"
            drilledDownGroupId={assignedGroupId}
            key="assignment"
            trigger={
              <a className={cn('menu-button', { assigned: isAssigned })}>
                {isAssigned && (
                  <span className="label">{assignmentAgentName}</span>
                )}
                {!isAssigned && (
                  <div className="hack-tooltip-wrapper">
                    <AssignIcon />
                  </div>
                )}
              </a>
            }
            open
            onClose={onAssignmentDropdownClose}
          />
        )}
      </div>
    )
  }
)

export default AssignmentButton
